import { render, staticRenderFns } from "./BotoesListagem.vue?vue&type=template&id=2bae8b10"
import script from "./BotoesListagem.vue?vue&type=script&lang=js"
export * from "./BotoesListagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports